import { server } from "../../server";
import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

function BusTiming() {
  const [busStoppageDetails, setBusStoppageDetails] = useState([]);
  const [busTimingDetails, setBusTimingDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState("");
  const [busDetails, setBusDetails] = useState([]);
  const MySwal = withReactContent(Swal);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;

  

  useEffect(() => {
    const fetchBusStoppages = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${server}/getAllBusStoppageMongoDb`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });
        const stoppages = response.data?.["body-json"]?.body?.stoppages;
        if (Array.isArray(stoppages)) {
          setBusStoppageDetails(stoppages);
        } else {
          console.error("Invalid data format from API:", response.data);
        }
      } catch (error) {
        console.error("Error fetching bus stoppages:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBusStoppages();
  }, []);

  useEffect(() => {
    const fetchBusDetails = async () => {
      try {
        const response = await axios.get(`${server}/allBusDetailsMongoDb`, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        });
        if (response.data && response.data["body-json"]?.body?.data) {
          setBusDetails(response.data["body-json"].body.data);
        } else {
          console.error("Invalid data format from API", response.data);
        }
      } catch (error) {
        console.error("Error fetching bus details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBusDetails();
  }, []);

  const fetchBusTimeTable = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${server}/GetAllBusTimeTables`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      if (Array.isArray(response.data)) {
        setBusTimingDetails(response.data);
      } else {
        setBusTimingDetails([]);
      }
    } catch (error) {
      setBusTimingDetails([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBusTimeTable();
  }, []);

  const [formData, setFormData] = useState({
    busNo: "",
    name: "",
    pickUpTiming: "",
    dropTiming: "",
  });

  const totalFields = Object.keys(formData).length;
  const filledFields = Object.values(formData).filter(
    (val) =>
      (typeof val === "string" && val.trim() !== "") ||
      (typeof val === "number" && val > 0)
  ).length;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.busNo ||
      !formData.name ||
      !formData.pickUpTiming ||
      !formData.dropTiming
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    const payload = {
      busNo: formData.busNo.trim(),
      stoppage: [
        {
          name: formData.name.trim(),
          pickUpTiming: formData.pickUpTiming.trim(),
          dropTiming: formData.dropTiming.trim(),
        },
      ],
    };

    setLoading(true);

    try {
      const response = await axios.post(
        "https://7otfgyv0ke.execute-api.ap-south-1.amazonaws.com/prod/AddBusTimeTable",
        payload,
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Bus Time Table Added", {
        position: "top-right",
      });

      // Close modal if open
      const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
      if (closeButton) closeButton.click();

      // Reset form
      setFormData({
        busNo: "",
        name: "",
        pickUpTiming: "",
        dropTiming: "",
      });
      fetchBusTimeTable();
    } catch (error) {
      toast.error("Failed to add timetable. Try again.", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  // Filter
  const filteredRecords = busTimingDetails.filter((driver) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(driver).some((value) => {
      if (typeof value === "string") {
        return value.toLowerCase().includes(searchLower);
      } else if (typeof value === "object" && value !== null) {
        return Object.values(value).some(
          (subValue) =>
            typeof subValue === "string" &&
            subValue.toLowerCase().includes(searchLower)
        );
      }
      return false;
    });
  });

  // ✅ Reset pagination when searching
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ Apply pagination AFTER filtering
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div
            class="modal fade gd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <form onSubmit={handleSubmit}>
                  <div class="modal-header d-flex justify-content-between">
                    <h5 class="modal-title fs-4" id="exampleModalToggleLabel">
                      Add Bus Timing{" "}
                      <span className="ms-3 text-secondary">
                        ({String(filledFields).padStart(2, "0")}/
                        {String(totalFields).padStart(2, "0")})
                      </span>
                    </h5>
                    <div className="d-flex align-items-center">
                      <span class="badge bg-success-soft me-3 px-3">
                        Editable
                      </span>
                      <div class="form-check form-switch me-4">
                        <input
                          type="checkbox"
                          class="form-check-input m-0"
                          checked
                        />
                      </div>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                  </div>

                  <div class="modal-body">
                    <div className="row g-2 mb-2">
                      <div className="col-lg-6 col-12">
                        <label className="form-label mb-1 ms-3">Bus No</label>
                        <Select
                          name="busNo"
                          value={
                            formData.busNo
                              ? { label: formData.busNo, value: formData.busNo }
                              : null
                          }
                          onChange={(selected) =>
                            handleChange({
                              target: {
                                name: "busNo",
                                value: selected?.value || "",
                              },
                            })
                          }
                          options={
                            Array.isArray(busDetails)
                              ? [...busDetails]
                                  .sort((a, b) => {
                                    const numA =
                                      parseInt(
                                        a?.generalInfo?.busNumber?.match(
                                          /\d+/
                                        )?.[0]
                                      ) || 0;
                                    const numB =
                                      parseInt(
                                        b?.generalInfo?.busNumber?.match(
                                          /\d+/
                                        )?.[0]
                                      ) || 0;
                                    return numA - numB;
                                  })
                                  .map((bus) => ({
                                    label: bus?.generalInfo?.busNumber || "",
                                    value: bus?.generalInfo?.busNumber || "",
                                  }))
                              : []
                          }
                        />
                      </div>

                      <div className="col-lg-6 col-12">
                        <label className="form-label mb-1 ms-3">
                          Stoppage Name
                        </label>
                        <Select
                          name="name"
                          value={
                            formData.name
                              ? { label: formData.name, value: formData.name }
                              : null
                          }
                          onChange={(selected) =>
                            handleChange({
                              target: {
                                name: "name",
                                value: selected?.value || "",
                              },
                            })
                          }
                          options={
                            Array.isArray(busStoppageDetails)
                              ? [...busStoppageDetails]
                                  .sort((a, b) =>
                                    a.stoppage.localeCompare(b.stoppage, "en", {
                                      sensitivity: "base",
                                    })
                                  )
                                  .map((item) => ({
                                    label: item.stoppage,
                                    value: item.stoppage,
                                  }))
                              : []
                          }
                        />
                      </div>

                      <div className="col-lg-6 col-12">
                        <label className="form-label mb-1 ms-3">
                          Pick UpTime
                        </label>
                        <input
                          type="time"
                          name="pickUpTiming"
                          className="form-control text-dark"
                          placeholder="e.g., 07:15 AM"
                          value={formData.pickUpTiming}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-lg-6 col-12">
                        <label className="form-label mb-1 ms-3">
                          Drop Time
                        </label>
                        <input
                          type="time"
                          name="dropTiming"
                          className="form-control text-dark"
                          placeholder="e.g., 02:30 PM"
                          value={formData.dropTiming}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer d-flex justify-content-between py-2">
                    <div>
                      <button
                        type="button"
                        class="btn btn-secondary px-3 me-1 rounded-pill"
                        data-bs-dismiss="modal"
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary px-5 rounded-pill fw-normal"
                        disabled={loading}
                      >
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="">
            <div class="container-fluid my-3 px-3">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                    <table class="table mb-0 text-nowrap table-centered">
                      <thead class="table-light">
                        <tr>
                          <th className="w-10">No.</th>
                          <th className="lh-1 w-60">
                            Details
                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Displaying Information as per Record
                            </span>
                          </th>
                          <th className="lh-1 w-30">
                            Action
                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Role-Specific Action Panel
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((bus, index) => (
                          <tr key={bus._id || index}>
                            <td>{indexOfFirstRecord + index + 1}.</td>
                            <td className="lh-sm py-4 text-wrap text-capitalize">
                              <span class="text-dark">Bus No.</span> &mdash;{" "}
                              {bus.busNo}
                              <hr className="w-25" />
                              {bus.stoppage?.map((stop, i) => (
                                <div key={i}>
                                  <span className="text-dark">
                                    Stoppage &mdash;{" "}
                                  </span>
                                  {stop.name} <br />
                                  <span className="text-dark">
                                    Pick Up &mdash;{" "}
                                  </span>
                                  {stop.pickUpTiming} <br />
                                  <span className="text-dark">
                                    Drop &mdash;{" "}
                                  </span>{" "}
                                  {stop.dropTiming}
                                  {i < bus.stoppage.length - 1 && (
                                    <hr className="w-25" />
                                  )}
                                </div>
                              ))}
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1 width-fit-content">
                                <span class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                  Update
                                </span>
                                <span class="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                  Delete
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div class="">
                    <div className="mb-3">
                      <div className="d-flex bg-white justify-content-between rounded-4">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                        <Link
                          data-bs-toggle="modal"
                          data-bs-target=".gd-example-modal-lg"
                          class="btn btn-warning px-5 fs-6 fw-medium rounded-4 fit-content"
                        >
                          Add Timing
                        </Link>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb pe-3">
                            <li class="breadcrumb-item">
                              <a href="#">Transport Management</a>
                            </li>
                            <li
                              class="breadcrumb-item active"
                              aria-current="page"
                            >
                              Bus Timing
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div className="p-4 bg-white rounded-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {loading ? (
                            <div
                              className="spinner-border text-dark data-loader-spinner"
                              role="status"
                            ></div>
                          ) : (
                            <img src="/assets/images/folder.svg" />
                          )}

                          <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                            Bus Timing
                            <br />
                            <span className="text-secondary fs-6 fw-medium lh-sm">
                              1.4 MB Size
                            </span>
                          </p>
                        </div>
                        <span className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer">
                          Export
                        </span>
                      </div>

                      <div class="px-4 py-2 mt-3 bg-light rounded-4">
                        <li className="list-group-item px-0">
                          <a
                            className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                            data-bs-toggle="collapse"
                            href="#specifications"
                            role="button"
                            aria-expanded="false"
                            aria-controls="specifications"
                          >
                            <p className="m-0 fw-medium lh-sm text-dark">
                              Download Report
                            </p>
                            <span className="chevron-arrow ms-4">
                              <i className="bi bi-chevron-down fs-4" />
                            </span>
                          </a>
                          <div
                            className="collapse"
                            id="specifications"
                            data-bs-parent="#ecommerceAccordion"
                          >
                            <div className="py-3">
                              <div class="rounded-4 d-flex flex-wrap">
                                <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                  All Timing
                                </span>
                                <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                  Similar Transport Fee Timing
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>

                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);

                            if (currentPage > 3) {
                              pageNumbers.push("left-ellipsis");
                            }

                            if (
                              currentPage !== 1 &&
                              currentPage !== totalPages
                            ) {
                              pageNumbers.push(currentPage);
                            }

                            if (currentPage < totalPages - 2) {
                              pageNumbers.push("right-ellipsis");
                            }

                            if (totalPages > 1) {
                              pageNumbers.push(totalPages);
                            }

                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default BusTiming;
